import SecondLevelItem from './SecondLevelItem.jsx';
import {useRef} from 'react';
import {useNaviFocusTrap} from '@header/scripts/components/hooks/use-navi-focus-trap.js';

export default function SecondLevelItems({
    secondLevelNavigationItems,
    currentHoveredItemId,
    setCurrentHoveredItemId,
    thirdLevelEmpty,
    closeLayer,
    disableFocusTrap = false,
}) {
    const secondLevelItems = useRef(null);
    useNaviFocusTrap(secondLevelItems, 'second', closeLayer, disableFocusTrap);

    return (
        <div
            ref={secondLevelItems}
            className="navigation__level-column -level:second bg-clr-bg-main-light"
            key="secon-level-items"
            tabIndex={-1}
        >
            {secondLevelNavigationItems
                .filter((item) => !item.overviewItem)
                .map((item, index) => (
                    <SecondLevelItem
                        key={index}
                        navigationItem={item}
                        setCurrentHoveredItemId={setCurrentHoveredItemId}
                        currentHoveredItemId={currentHoveredItemId}
                        thirdLevelEmpty={thirdLevelEmpty}
                    />
                ))}
        </div>
    );
}
